"use strict";

// navitime API連携
const sid = "10354370"; // YOUR_SID （本番用）
// const sid = "10354360"; // YOUR_SID （テスト環境用）

// eslint-disable-next-line no-unused-vars
const signatureKey = "R3mSJLiG0M9oPgxWzsXPOgFJF0FMMnJI";// YOUR_PRIVATE_KEY （本番用）
// const signatureKey = "KFYkxJp5YtXRKMAHOP7TjvepA7CJiVTy";// YOUR_PRIVATE_KEY （テスト環境用）

const endpoint = `https://dp.navitime.biz/s1/${sid}/shop/list`;

/**
 * 最近チェックした2つの店舗を LocalStorage に保存する。
 * @param {Object} shop NAVTIME の API から取得した店舗情報
 * @return {undefined}
 */
const setRecentlySearchedShops = (shop) => {
  const text = localStorage.getItem("recently_searched_shops");
  const array = text ? JSON.parse(text) : [];

  // Set でユニークな店舗のみを格納するために、
  // shop オブジェクトを文字列に変換して、配列の先頭に追加する。
  array.unshift(JSON.stringify(shop));

  // すでにチェック済みの店舗が再度チェックされた場合、
  // その重複した店舗を同時に格納せず、ユニークな店舗（先頭の店舗）のみ格納する。
  const uniqueArray = Array.from(new Set(array));

  if (uniqueArray.length > 2) {
    uniqueArray.length = 2;
  }

  localStorage.setItem("recently_searched_shops", JSON.stringify(uniqueArray));
};

/**
 * LocalStorage に保存している最近チェックした店舗を表示する。
 * @return {undefined}
 */
const showRecentlySearchedShops = () => {
  const recentlySearchedShops = document.getElementById(
    "recently-searched-shops"
  );
  const text = localStorage.getItem("recently_searched_shops");

  if (!recentlySearchedShops || !text) {
    return;
  }

  const array = JSON.parse(text);

  let html = `
    <div class="recentlySearchedShops">
      <p class="recentlySearchedShops__title">最近チェックした店舗</p>
      <ul class="recentlySearchedShops__list">
  `;

  array.forEach((text) => {
    const shop = JSON.parse(text);

    html += `
      <li>
        <a
          class="recentlySearchedShops__link"
          href="https://www.google.com/maps?q=${shop.address_name}"
          target="_blank"
        >${shop.name}</a>
      </li>
    `;
  });

  html += `</ul></div>`;

  recentlySearchedShops.innerHTML = html;
};

showRecentlySearchedShops();

const addNearbyShops = (shops) => {
  const shopList = document.getElementById("js-shop-list");
  const status = document.querySelector(".status");

  for (const shop of shops) {
    const shopname = document.createTextNode(shop.name);
    const shopaddress = document.createTextNode(shop.address_name);
    const mapurl = "https://www.google.com/maps?q=" + shop.address_name;

    const shoplistItem = document.createElement("li");
    shoplistItem.classList.add("shopsModal__listItem");

    // 店舗名
    const shopName = document.createElement("p");
    shopName.classList.add("shop__name");

    // 店舗住所
    const shopAddress = document.createElement("p");
    shopAddress.classList.add("shop__address");

    // Google map
    const shopmap = document.createElement("a");
    shopmap.classList.add("shop__map");
    shopmap.href = mapurl;
    shopmap.setAttribute("target", "_blank");
    shopmap.innerHTML =
      'Google Map<span><img src="https://cdn.shopify.com/s/files/1/0686/6426/2971/files/icon-map.svg?v=1679614286" width="11" height="11" decording="async"></span>';
    shopmap.dataset.name = shop.name;

    shopmap.addEventListener("click", () => {
      setRecentlySearchedShops(shop);
      showRecentlySearchedShops();
    });

    const moreButton = document.getElementById("js-shops-modal-more");

    shopName.appendChild(shopname);
    shopAddress.appendChild(shopaddress);
    shoplistItem.appendChild(shopName);
    shoplistItem.appendChild(shopAddress);
    shoplistItem.appendChild(shopmap);
    shopList.insertBefore(shoplistItem, moreButton);
  }
  status.textContent = "";
};

const geoFindMe = () => {
  const status = document.querySelector(".status");

  function success(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;

    //   const toString = Object.prototype.toString;

    const url = `${endpoint}?coord=${latitude},${longitude}&radius=25000&c_dc3=1`;

    fetch(url)
      .then((responce) => {
        // エラーレスポンスが返されたことを検知する
        if (!responce.ok) {
          console.error("エラーレスポンス", responce);
        } else {
          return responce.json().then((data) => {
            addNearbyShops(data.items);
          });
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  function error() {
    status.textContent = "現在地を取得できません";
    const modal = document.querySelector(".shopsModal__inner");
    modal.classList.add("error");
  }

  if (!navigator.geolocation) {
    status.textContent = "ジオロケーションはブラウザでサポートされていません";
  } else {
    status.innerHTML = '<div class="shopsModal__loading"></div>';
    navigator.geolocation.getCurrentPosition(success, error);
  }
};

// const searchButtons = document.querySelectorAll(".js-search-button");
// searchButtons.forEach((searchButton) => {
//   searchButton.addEventListener("click", geoFindMe);
// });
geoFindMe()

// 店舗一覧モーダル
const shopModal = () => {
  const modal = document.getElementById("js-shops-modal");
  const searchButtons = document.querySelectorAll(".js-search-button");
  const closeButtons = document.querySelectorAll(".js-shops-modal-close");

  let isOpen = false;

  const changeAriaAttribute = () => {
    const hidden = isOpen ? "false" : "true";
    const expanded = isOpen ? "true" : "false";

    modal.setAttribute("aria-hidden", hidden);
    searchButtons.forEach((searchButton) => {
      searchButton.setAttribute("aria-expanded", expanded);
    });

    closeButtons.forEach((closeButton) => {
      closeButton.setAttribute("aria-expanded", expanded);
    });
  };

  const open = () => {
    isOpen = true;
    changeAriaAttribute();
  };

  const close = () => {
    isOpen = false;
    changeAriaAttribute();
  };

  const rootElement = document.documentElement;
  const scrollLockModifier = "shopsModalOpen";

  function activateScrollLock() {
    rootElement.classList.add(scrollLockModifier);
  }

  function deactivateScrollLock() {
    rootElement.classList.remove(scrollLockModifier);
  }

  const handleOpenButtonClick = () => {
    activateScrollLock();
    open();
  };

  const handleCloseButtonClick = () => {
    deactivateScrollLock();
    close();
  };

  searchButtons.forEach((searchButton) => {
    searchButton.addEventListener("click", handleOpenButtonClick);
  });

  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener("click", handleCloseButtonClick);
  });
};
shopModal();

const geoFindMeAgain = () => {
  const searchAgainButton = document.querySelector(".js-search-again-button");
  const shopList = document.getElementById("js-shop-list");

  const moreButton = document.createElement("button");
  moreButton.classList.add("shopsModal__moreButton");
  moreButton.setAttribute("id", "js-shops-modal-more");
  moreButton.textContent = "もっと見る";

  searchAgainButton.addEventListener("click", () => {
    if (!(moreButton.length > 1)) {
      shopList.innerHTML = "";

      shopList.appendChild(moreButton);
      geoFindMe();
    }
  });
};
geoFindMeAgain();

const moreShops = () => {
  const moreBUtton = document.getElementById("js-shops-modal-more");
  const modal = document.getElementById("js-shops-modal");

  moreBUtton.addEventListener("click", () => {
    modal.classList.add("more");
  });
};
moreShops();
